import React, { Component } from 'react';
import { HorizontalBar } from 'react-chartjs-2';
import _ from 'lodash';

export default class PortfolioGains extends Component {

    render() {

        let succ_color = "#23d160";
        let err_color = "#ff3860";

        let data = null;
        let options = {
            legend: false,
            drawTicks: false,
            drawBorder: false,
            'scaleShowLabels': false,
            scales: {
                xAxes: [{
                    gridLines: {
                        display: false
                    }
                }],
                yAxes: [{
                    gridLines: {
                        display: false
                    }
                }]
            }
        }  
        if (this.props.positions && this.props.positions.length > 0) {

            data = {
                labels: [],
                datasets: [{
                    data: [],
                    backgroundColor: [],
                    hoverBackgroundColor: []
                }]
            };
            let color_index = -1;
            if (this.props.today==false) {

                for (var pos_item of this.props.positions) {

                    color_index = color_index + 1;
                    data.labels.push(pos_item.symbol);
                    data.datasets[0].data.push(pos_item.unrealized_gains > 0 ? pos_item.unrealized_gains.toFixed(2) : (-1 * pos_item.unrealized_gains.toFixed(2)));
                    data.datasets[0].backgroundColor.push(pos_item.unrealized_gains > 0 ? succ_color : err_color);
                }
            }
            else {
                for (var pos_item of this.props.positions) {

                    color_index = color_index + 1;
                    data.labels.push(pos_item.symbol);
                    data.datasets[0].data.push(pos_item.today_gains > 0 ? pos_item.today_gains.toFixed(2) : (-1 * pos_item.today_gains.toFixed(2)));
                    data.datasets[0].backgroundColor.push(pos_item.today_gains > 0 ? succ_color : err_color);
                }
            }
            // }
            // data = {
            //     labels: [
            //         'Red',
            //         'Green',
            //         'Yellow'
            //     ],
            //     datasets: [{
            //         data: [300, 50, 100],
            //         backgroundColor: [
            //             '#FF6384',
            //             '#36A2EB',
            //             '#FFCE56'
            //         ],
            //         hoverBackgroundColor: [
            //             '#FF6384',
            //             '#36A2EB',
            //             '#FFCE56'
            //         ]
            //     }]
            // };
        }

        return (<div>
            {data &&
                <HorizontalBar data={data} options={options} type={'horizontalBar'} />
            }
        </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/portfolio-gains.js